import { css } from 'linaria';
export const printLayout = "pinp2nh";

require("./print-layout.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./print-layout.js");